import React from "react";
import Navbar from "../../../../components/Navbar/Navbar";
import Banner from "../../../../components/body/topLocationsComponents/locationsComponents/Banner";
import { BannerData, LocationData } from "./data";
import LocationComponentsCard from "../../../../components/body/topLocationsComponents/locationsComponents/LocationComponentsCard ";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";
const NorthMumbai = () => {
  return (
    <div>
      <Navbar />
      <Banner BannerData={BannerData} />
      <LocationComponentsCard LocationData={LocationData} />

      <Main_Footer />
    </div>
  );
};
export default NorthMumbai;
